import { useDispatch } from "react-redux";

import { addNewItem } from "../../apis/cartsApiSlice";

const ProductDetails = ({ product }) => {
  const dispatch = useDispatch();

  const starRatings = (rating) => {
    const rateElements = [];
    const rate = Math.round(rating);

    for (let i = 1; i < 6; i++) {
      rateElements.push(
        <span key={i}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={i < rate ? "#000" : "none"}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
            ></path>
          </svg>
        </span>
      );
    }

    return rateElements;
  };

  return (
    <div className="flex flex-wrap sm:flex-nowrap gap-8 sm:gap-16 items-start w-full p-8 shadow-lg">
      <div className="flex flex-grow sm:flex-grow-0 items-center justify-center">
        <img
          className="w-[500px] h-auto"
          src={product.image}
          alt={product.title}
        />
      </div>
      <div className="flex flex-col">
        <h4 className="text-2xl sm:mt-10 mb-4">{product.title}</h4>
        <div className="inline-flex items-center">
          {starRatings(product?.rating.rate)}
        </div>
        <div className="mt-4">
          <p>{product.description}</p>
        </div>
        <p className="text-lg mt-4 mb-6">$ {product.price.toFixed(2)}</p>
        <div className="mt-auto mb-0">
          <button className="bg-secondary py-4 px-6 rounded-md" onClick={(e) => { dispatch(addNewItem(product.id)); }}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
